import fetchAddress from './fetchAddress';
import fetchFulfilmentLocation from './fetchFulfilmentLocation';

const fetchShipmentAddressing = async (shipment, excludeTypes = []) => {
  try {
    const addressing = shipment?.addressing ?? {};
    const promises = Object.keys(addressing)
      .filter(key => !excludeTypes.includes(key))
      .map(async key => {
        const { entity_id: id, entity_type: type } = addressing[key];
        if (type === 'location') {
          return { [key]: await fetchFulfilmentLocation(id).catch(() => null) };
        }

        return { [key]: await fetchAddress(id).catch(() => null) };
      });

    return Promise.allSettled(promises).then(result =>
      result
        .filter(promise => promise.status === 'fulfilled')
        .reduce((acc, response) => ({ ...acc, ...(response?.value ?? {}) }), {}),
    );
  } catch (err) {
    return Promise.reject(err);
  }
};

export default fetchShipmentAddressing;
